import { FC } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Trash2 } from "lucide-react"
import SendEmailToCustomerButton from "./SendEmailToCustomerButton"
import { Button } from "./ui/button"

const AccountSummary: FC<{
  onClickEmailButton?: () => void
  customerEmail?: string
  customerName?: string
  onDeleteCustomer?: () => void
  isDeletingCustomer?: boolean
  canWriteCustomer?: boolean
  canMutateCustomer?: boolean
}> = ({ customerEmail, customerName, onDeleteCustomer, isDeletingCustomer = false, canWriteCustomer = false, canMutateCustomer = false }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Customer Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <SendEmailToCustomerButton
            customerEmail={customerEmail ?? ""}
            customerName={customerName ?? ""}
            disabled={!canWriteCustomer}
          />
        </div>
        <div className="space-y-3 border-t pt-4">
          <div>
            <p className="text-sm font-medium text-destructive">Delete customer</p>
            <p className="text-xs text-muted-foreground">
              Mark this customer as deleted and prevent future login. Customer data remains
              available for audit/history.
            </p>
          </div>
          <Button
            variant="destructive"
            size="sm"
            className="w-full"
            onClick={onDeleteCustomer}
            disabled={!canMutateCustomer || isDeletingCustomer || !onDeleteCustomer}
          >
            <Trash2 className="size-4" />
            Delete Customer
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}

export default AccountSummary
